export default __webpack_public_path__ + "static/media/main.0a7c9dc3.png";